import React, { useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';

// ========= action import section ========= //
// ====== end of action import section ====== //

// ========= interface import section ========= //
// ====== end of interface import section ====== //

import EMPTY_STATE from '../../../images/dashboard-empty-state.jpg';
import HOLIDAY_MODE from '../../../images/holidaymode1024.png';
import WARNING_ICON from '../../../images/warning-icon.png';
import moreIcon from "../../../images/more.png"
import HOLIDAY_ICON_RED from '../../../images/holiday-icon-red.png';
import _ from 'lodash';
import moment from 'moment';
import { IconContext } from 'react-icons';
import { MdSettings } from 'react-icons/md';
import ReactLoading from 'react-loading';
import AuthInterface from '../../../interface/reducers/auth';
import DataHistoryInterface, {
  PenjualanInterface,
  DataPenjualanProgressInterface,
} from '../../../interface/reducers/history';
import {
  dustBag,
  boxHandbag,
  WAREHOUSE,
  convertToRupiah,
  _NEW,
} from '../../../utils';
import {
  sneakersCondition,
  accessoriesCondition,
  handbagCondition,
  boxCondition,
  defectCondition,
  handleImageCategory,
  formatCurrency,
} from '../../../utils/Helpers';
import TableHeader from '../components/TableHeader';
import ModalHistorySelling from '../components/ModalHistorySelling';
import CreditMinus from "./components/CreditMinus";
import Suspended from "./components/Suspended";

const moreIconNew: any = moreIcon

type stateToProps = {
  dataHistory: DataHistoryInterface;
  dataAuth: AuthInterface;
};

interface HistoryInterface {
  dataSelling: PenjualanInterface;
  roles: string[];
  ratio: number;
  currency: string;
  isHoliday: boolean;
  callbackAfterUpdate: (...args: any) => any;
  loading: boolean;
  dataAuth: any;
  setIsOpenModalAlert: () => any;
}

/**
 * History tab on Selling User Dashboard section for Kick Avenue 3.0 Website.
 * Author: Rifqy Zacky Ariadhy (rifqyzackya@gmail.com)
 * ===============================================
 * @param {HistoryInterface} props for this component.
 * @return {JSX.Element}
 */
function HistoryTab({
  dataSelling,
  roles,
  ratio,
  currency,
  isHoliday,
  callbackAfterUpdate,
  loading,
  dataAuth,
  setIsOpenModalAlert,
  seller_points
}: HistoryInterface): JSX.Element {
  const hasSuspendedSeller = dataAuth?.userdata?.roles?.includes('suspended_seller');
  const sellerPointsLessThanFive = parseInt(seller_points) < 5;
  const isSuspended = hasSuspendedSeller || sellerPointsLessThanFive;

  const isSellerCreditMinus = parseInt(dataAuth?.userdata?.balance_with_fee ?? "0") < 0

  const [isModalOpened, setModalOpened] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  /**
   * Table item for In Progress List in Selling Dashboard
   * @param {DataPenjualanProgressInterface} item
   * @return {JSX.Element}
   */
  function renderItem(item: DataPenjualanProgressInterface): JSX.Element {
    const uniqueDefects = _.uniqBy(item?.user_sell?.defects, 'name');
    const dustBagCondition = uniqueDefects
      ? uniqueDefects.find((a: any) => a.name === 'DUST_BAG')
      : {};
    const boxConditions = uniqueDefects
      ? uniqueDefects.find((a: any) => a.name === 'BOX')
      : {};
    const hideBoxInfo = item?.user_sell?.product_variant?.hide_box_info;
    const isVintage = item?.user_sell?.product_variant?.vintage;
    const luxuryDetailArr = [
      sneakersCondition(item?.sale[0].sale_product?.sneakers_condition),
      accessoriesCondition(item?.sale[0].sale_product?.missing_accessories),
      dustBag(dustBagCondition),
      hideBoxInfo ? '' : boxHandbag(boxConditions),
      item?.sale[0].sale_product?.sneakers_defect
        ? handbagCondition(uniqueDefects)
        : '',
    ];
    const luxuryDetail = luxuryDetailArr
      .filter((item) => item !== '' && item !== 'Missing Box')
      .map((item) => item)
      .join(' / ');
    const handleClickedDetail = () => {
      setSelectedData(item);
      setModalOpened(true);
    };

    const category = item?.sale[0].sale_product?.category_name;
    const isTicket = item?.user_sell?.product_variant?.product?.name.includes('Ticket');

    return (
      <div className={'item-table'}>
        <div className={'product-container'}>
          <KickImage
            src={handleImageCategory(isTicket, category.toLowerCase())}
            className={'image-category'}
          />
          <div>
            <p className={'title'}>
              {item?.sale[0].sale_product?.display_name}
            </p>
            {category === 'handbags' ||
            (category === 'lifestyles' &&
              item?.sale[0].sale_product?.size?.US.toLowerCase() !== 'all size') ? (
              <div className={'size-container'}>
                <p>{item?.sale[0].sale_product?.size?.US}</p>
              </div>
            ) : (
              <div className={'size-container'}>
                <p>US {item?.sale[0].sale_product?.size?.US}</p>
              </div>
            )}
            <p className={'condition'}>{item.invoice_number}</p>
            <p className={'extra'}>{item?.user_sell?.product_variant?.colour}</p>
            {/* <p className={'condition'}>
              {isVintage
                ? 'Vintage'
                : item?.sale[0].sale_product?.category_name === 'sneakers' ||
                  item?.sale[0].sale_product?.category_name === 'lifestyles'
                ? `${sneakersCondition(
                    item?.sale[0].sale_product?.sneakers_condition,
                  )} /  ${boxCondition(
                    item?.sale[0].sale_product?.box_condition,
                  )} / ${accessoriesCondition(
                    item?.sale[0].sale_product?.missing_accessories,
                  )}`
                : item?.sale[0].sale_product?.category_name === 'apparels'
                ? defectCondition(
                    item?.sale[0].sale_product?.sneakers_defect,
                    item,
                  )
                : luxuryDetail}
            </p> */}
            <p className={'extra'}>
              Consignment ID:{' '}
              {item?.sale[0].sale_product?.consignment_id ?? '-'}
            </p>
          </div>
        </div>
        <div className={'price-progress-container history'}>
          <p>{formatCurrency(item.sale[0].seller_price, ratio, currency)}</p>
        </div>
        <div className={'status-progress-container history'}>
          <div>
            <p className={'status'}>
              {moment(item.sale[0].created_at).format('MMMM DD, YYYY')}
            </p>
          </div>
          <IconContext.Provider value={{ color: '#242424', size: '15px' }}>
            <div className={'icon-container'} onClick={handleClickedDetail}>
              {/* <MdSettings /> */}
              <KickImage src={moreIconNew} alt="..." />
            </div>
          </IconContext.Provider>
        </div>
      </div>
    );
  }

  /**
   * Rendering Empty State UI
   * @return {JSX.Element}
   */
  function renderEmpty() {
    return (
      <div className={'empty-container'}>
        <KickImage src={EMPTY_STATE} />
        <p>It seems you haven’t got anything on sale history.</p>
        <div className={'button-refresh'} onClick={callbackAfterUpdate}>
          <p>Refresh</p>
        </div>
      </div>
    );
  }

  /**
   * Rendering Holiday Mode UI
   * @return {JSX.Element}
   */
  function renderHoliday() {
    return (
      <>
        {
          /* Uncomment to Render suspended if needed in future
          isSuspended ?
            <Suspended onClick={() => setIsOpenModalAlert()} />
            :
           */
          !isSellerCreditMinus ?
            (<div className={'empty-container'}>
              <KickImage src={HOLIDAY_MODE} />
              <p className={'title'}>Holiday mode is currently set to active</p>
              <p className={'bottom-text'}>
                All your listings are being temporarily deactivated. You can anytime
                re-activate your listings. Enjoy your break!
              </p>
            </div>)
            : (
              <CreditMinus onClick={() => setIsOpenModalAlert()} />
            )

        }
      </>
    );
  }

  return (
    <div>
      <TableHeader
        getData={callbackAfterUpdate}
        type={'history'}
        mode={'selling'}
        isHoliday={isHoliday}
      />
      <div className={'table-container'}>
        <div className={'header-table'}>
          <div className={'product-container'}>
            <span>Product</span>
          </div>
          <div className={'revenue-container'}>
            <span>Revenue</span>
          </div>
          <div className={'sold-container'}>
            <span>Sold Date</span>
          </div>
        </div>
        <div className={'body-table'}>
          {/* {isHoliday || isSuspended ? ( */}
          {isHoliday ? (
            renderHoliday()
          ) : dataSelling.isFetch || loading ? (
            <div className={'empty-container'}>
              <ReactLoading
                type={'spin'}
                height={50}
                width={50}
                color={'#159953'}
              />
            </div>
          ) : dataSelling.dataPenjualan.length ? (
            dataSelling.dataPenjualan.map((item) => renderItem(item))
          ) : (
            renderEmpty()
          )}
        </div>
      </div>
      <ModalHistorySelling
        isOpen={isModalOpened}
        onToggle={() => setModalOpened(false)}
        callbackAfterUpdate={callbackAfterUpdate}
        data={selectedData}
      />
    </div>
  );
}

const mapStateToProps = (state: stateToProps) => {
  return {
    dataSelling: state.dataHistory.history,
    roles: state.dataAuth.userdata.roles,
    ratio: state.dataAuth.userCurrency.ratio,
    currency: state.dataAuth.userCurrency.currency,
    isHoliday: state.dataAuth.userdata.is_holiday,
    dataAuth: state.dataAuth,
    seller_points: state.dataAuth.userdata.seller_points,
  };
};

const mapDispatchToProps = (dispatch: (arg0: any) => any) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(HistoryTab);
